import {
  getTextModelFromEditorModel,
  useActiveTextEditor,
} from "components/Layout/Panels/VSCode/utils";
import { useCallback } from "react";

export const useGetSelectedTextFromEditor = () => {
  const activeTextEditor = useActiveTextEditor();

  return useCallback(async () => {
    if (!activeTextEditor) {
      return undefined;
    }

    const selection = activeTextEditor.getSelection();
    if (!selection) {
      return undefined;
    }

    const model = activeTextEditor.getModel();
    if (!model) {
      return undefined;
    }

    const textModel = getTextModelFromEditorModel(model);

    return {
      text: textModel.getValueInRange(selection),
      range: selection,
    };
  }, [activeTextEditor]);
};
